var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBenfitCustomer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0004 9.54651C23.9204 9.53318 23.8271 9.53318 23.7471 9.54651C21.9071 9.47984 20.4404 7.97317 20.4404 6.10651C20.4404 4.19984 21.9738 2.6665 23.8804 2.6665C25.7871 2.6665 27.3204 4.21317 27.3204 6.10651C27.3071 7.97317 25.8404 9.47984 24.0004 9.54651Z",
    stroke: "url(#paint0_linear_99_309)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6275 19.2534C24.4542 19.5601 26.4675 19.2401 27.8809 18.2934C29.7609 17.0401 29.7609 14.9867 27.8809 13.7334C26.4542 12.7867 24.4142 12.4667 22.5875 12.7867",
    stroke: "url(#paint1_linear_99_309)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96063 9.54651C8.04063 9.53318 8.13396 9.53318 8.21396 9.54651C10.054 9.47984 11.5206 7.97317 11.5206 6.10651C11.5206 4.19984 9.98729 2.6665 8.08063 2.6665C6.17396 2.6665 4.64062 4.21317 4.64062 6.10651C4.65396 7.97317 6.12063 9.47984 7.96063 9.54651Z",
    stroke: "url(#paint2_linear_99_309)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33399 19.2534C7.50732 19.5601 5.49399 19.2401 4.08065 18.2934C2.20065 17.0401 2.20065 14.9867 4.08065 13.7334C5.50732 12.7867 7.54732 12.4667 9.37398 12.7867",
    stroke: "url(#paint3_linear_99_309)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 19.5065C15.9202 19.4931 15.8269 19.4931 15.7469 19.5065C13.9069 19.4398 12.4402 17.9331 12.4402 16.0665C12.4402 14.1598 13.9735 12.6265 15.8802 12.6265C17.7869 12.6265 19.3202 14.1731 19.3202 16.0665C19.3069 17.9331 17.8402 19.4531 16.0002 19.5065Z",
    stroke: "url(#paint4_linear_99_309)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1197 23.7065C10.2397 24.9598 10.2397 27.0131 12.1197 28.2665C14.2531 29.6931 17.7464 29.6931 19.8797 28.2665C21.7597 27.0131 21.7597 24.9598 19.8797 23.7065C17.7597 22.2932 14.2531 22.2932 12.1197 23.7065Z",
    stroke: "url(#paint5_linear_99_309)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_99_309",
    x1: 23.8804,
    y1: 2.6665,
    x2: 23.8804,
    y2: 9.54651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53A6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_99_309",
    x1: 25.9392,
    y1: 12.6665,
    x2: 25.9392,
    y2: 19.3659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53A6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_99_309",
    x1: 8.08062,
    y1: 2.6665,
    x2: 8.08062,
    y2: 9.54651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53A6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_99_309",
    x1: 6.02232,
    y1: 12.6665,
    x2: 6.02232,
    y2: 19.3659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53A6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_99_309",
    x1: 15.8802,
    y1: 12.6265,
    x2: 15.8802,
    y2: 19.5065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53A6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_99_309",
    x1: 15.9997,
    y1: 22.6465,
    x2: 15.9997,
    y2: 29.3365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53A6FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenfitCustomer);
export default __webpack_public_path__ + "static/media/benfit-customer.53c74440ab9cee3dc0ba08228cd14537.svg";
export { ForwardRef as ReactComponent };